import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.scss';

export default function NotFound() {
    const path = window.location.pathname;
    const isLocked = path === '/managers' || path === '/attached-group';

    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <h1 className={styles.errorCode}>404</h1>

                <div className={styles.divider} />

                {isLocked ? (
                    <>
                        <h2 className={styles.title}>Aðgangur takmarkaður</h2>
                        <p className={styles.description}>
                            Þessar stillingar eru læstar fyrir deilihópum.
                            Hafðu samband við{' '}
                            <a href="mailto:spara@spara.is" style={{ color: 'inherit', fontWeight: 600 }}>
                                spara@spara.is
                            </a>{' '}
                            fyrir frekari upplýsingar.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className={styles.title}>Úps! Þetta er vandræðalegt.</h2>
                        <p className={styles.description}>
                            Við fundum ekki síðuna sem þú varst að leita að. Við biðjumst innilega afsökunar á þessum óþægindum.
                        </p>
                    </>
                )}

                <Link to="/" className={styles.button}>
                    Fara á forsíðu
                </Link>
            </div>
        </div>
    );
}
